/**
 * @generated SignedSource<<5a395b57b5479b98802345a3035f9164>>
 * @relayHash 4916174f072d91013ee88b00df5a599d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9a10526e04b325b75cbfa8b7223be6764c00bb56d37ceb99d801b16a8cef858b

import type { ConcreteRequest } from 'relay-runtime';
export type ScreenQuery$variables = {
  spaceKey: string;
};
export type ScreenQuery$data = {
  readonly space: {
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type ScreenQuery = {
  response: ScreenQuery$data;
  variables: ScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ScreenQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScreenQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4916174f072d91013ee88b00df5a599d",
    "id": "9a10526e04b325b75cbfa8b7223be6764c00bb56d37ceb99d801b16a8cef858b",
    "metadata": {},
    "name": "ScreenQuery",
    "operationKind": "query",
    "text": "query ScreenQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
  }
};
})();

(node as any).hash = "7541db49d7b32f219252a52f0411cbca";

export default node;
